import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'skukey' })
export class SkuKeyPipe implements PipeTransform {
    propertyTypes = {
        'HIQFULL': 'Full Spekwo',
        'GCCONSULTING': 'Walk and Talk',
        'INSPECTIONCALL': 'SpeK - Call',
        'RJCZPSJ': 'The Pre-List speK-Sheet',
        'CGPYWCK': 'Specific Item speKwo',
    };
    transform(argu: any, args?: any): any {
        let final = [];
        if (argu !== null && argu !== '') {
            var data = JSON.parse(argu);
            _.each(data, value => {
                final.push(this.propertyTypes[value])
            })
            return final.toString();
        } else {
            return '';
        }

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/skuType.pipe.ts